var map = {
	"./YDBannerSlideshow": "./components/YDBanners/templates/YDBannerSlideshow.js",
	"./YDBannerSlideshow.css": "./components/YDBanners/templates/YDBannerSlideshow.css",
	"./YDBannerSlideshow.js": "./components/YDBanners/templates/YDBannerSlideshow.js",
	"./YDBannerSlideshow.module": "./components/YDBanners/templates/YDBannerSlideshow.module.css",
	"./YDBannerSlideshow.module.css": "./components/YDBanners/templates/YDBannerSlideshow.module.css",
	"./YDBannerTemplate1": "./components/YDBanners/templates/YDBannerTemplate1.js",
	"./YDBannerTemplate1.js": "./components/YDBanners/templates/YDBannerTemplate1.js",
	"./YDBannerTemplate1.module": "./components/YDBanners/templates/YDBannerTemplate1.module.css",
	"./YDBannerTemplate1.module.css": "./components/YDBanners/templates/YDBannerTemplate1.module.css",
	"./YDBannerTemplate2": "./components/YDBanners/templates/YDBannerTemplate2.js",
	"./YDBannerTemplate2.js": "./components/YDBanners/templates/YDBannerTemplate2.js",
	"./YDBannerTemplate2.module": "./components/YDBanners/templates/YDBannerTemplate2.module.css",
	"./YDBannerTemplate2.module.css": "./components/YDBanners/templates/YDBannerTemplate2.module.css",
	"./YDBannerTemplate3": "./components/YDBanners/templates/YDBannerTemplate3.js",
	"./YDBannerTemplate3.js": "./components/YDBanners/templates/YDBannerTemplate3.js",
	"./YDBannerTemplate3.module": "./components/YDBanners/templates/YDBannerTemplate3.module.css",
	"./YDBannerTemplate3.module.css": "./components/YDBanners/templates/YDBannerTemplate3.module.css",
	"./YDBannerTemplate4": "./components/YDBanners/templates/YDBannerTemplate4.js",
	"./YDBannerTemplate4.js": "./components/YDBanners/templates/YDBannerTemplate4.js",
	"./YDBannerTemplate4.module": "./components/YDBanners/templates/YDBannerTemplate4.module.css",
	"./YDBannerTemplate4.module.css": "./components/YDBanners/templates/YDBannerTemplate4.module.css"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components/YDBanners/templates sync recursive ^\\.\\/.*$";